import { useState } from 'react';
import type { HighLevelIssue } from '../types/content';
import { getCategoryImageUrl } from '../lib/categoryImages';

interface CategoryImageProps {
  issue: Pick<HighLevelIssue, 'slug' | 'title'>;
  className?: string;
  /** When true, image is decorative (empty alt). */
  decorative?: boolean;
}

export function CategoryImage({ issue, className, decorative }: CategoryImageProps) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return <div className={`category-image-fallback ${className ?? ''}`} aria-hidden />;
  }

  return (
    <img
      src={getCategoryImageUrl(issue)}
      alt={decorative ? '' : issue.title}
      className={className}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
